import { useEffect } from 'react';

// Handle scrolling to element on direct navigation to [domain]/#sectionId
function ScrollToHashOnLoad({ offset = 0 }: { offset?: number }) {
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
        const id = hash.replace('#', '');

        // Wait for layout to settle before performing the navigation
        setTimeout(() => {
            const el = document.getElementById(id);
            if (!el) return;

            const y = el.getBoundingClientRect().top + window.scrollY - offset;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }, 500);

    }
  }, [offset]);

  return null;
}

export default ScrollToHashOnLoad;